import type { CellValue } from "@/apps/engagement-letter-database/data/types";

export function stringify(value: CellValue): string {
  if (value == null) return '';
  if (value instanceof Date) return value.toISOString();
  return String(value);
}